/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import styles from './projDashboard.module.css';
import { ProjectDashboardNav, MyProjects, MyApplications, Navbar } from '../../../Components';
import { AppStates } from '../../../Context/appContext';
import { axios, PROJECTS } from '../../../api';
import { sendReqToServer } from '../../../Hooks/useAxios';
import { useDispatch, useSelector } from 'react-redux';
import { set_MyProjects } from '../../../redux/slices/myprojects-slices';

export default function ProjectDashboard() {
  //context
  const { user, setShowLoginPopup } = AppStates();

  //redux
  const dispatch = useDispatch();
  const myProjects = useSelector((state) => {
    return state.myProjects;
  });

  const [selectedTab, setSelectedTab] = useState('APPLICATIONS');
  const [myApplications, setMyApplications] = useState([]);

  async function fetchMyApplications() {
    try {
      const { response, error } = await sendReqToServer({
        axiosInstance: axios,
        url: PROJECTS.applications,
        method: 'POST',
        requestConfig: {
          userId: user._id,
        },
      });

      // console.log("My Applications: " , response?.body?.myApplications)
      setMyApplications(response?.body?.myApplications);
    } catch (err) {
      console.log(err);
    }
  }

  async function fetchMyProjects() {
    try {
      const { response, error } = await sendReqToServer({
        axiosInstance: axios,
        url: PROJECTS.myprojects,
        method: 'POST',
        requestConfig: {
          userId: user._id,
        },
      });

      // console.log("My Projects: ", response?.body?.myProjects);
      dispatch(set_MyProjects(response?.body?.myProjects));
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    async function fetchData() {
      if (user) {
        if (selectedTab === 'APPLICATIONS') {
          await fetchMyApplications();
        } else {
          await fetchMyProjects();
        }
      }
    }

    fetchData();
  }, [user, selectedTab]);

  return (
    <>
      <Navbar />
      <div className={styles.dbWrapper}>
        <ProjectDashboardNav selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

        <div className={styles.dashboardRight}>
          {(myApplications || myProjects) &&
            (selectedTab === 'APPLICATIONS' ? (
              <MyApplications applications={myApplications} />
            ) : (
              <MyProjects projects={myProjects} />
            ))}
        </div>
      </div>
    </>
  );
}
